import React, { useState, useEffect } from "react";
import axios from "axios";
import "./FAQs.css";

const FAQs = () => {
  const [isAnswerVisible, setIsAnswerVisible] = useState([]);
  const [faqs, setFaqs] = useState([]);
  useEffect(() => {
    const getFAQs = async () => {
      try {
        const response = await axios.get(
          "http://127.0.0.1:8000/admins/get-all-faqs"
        );

        if (response.status === 200) {
          setFaqs(response.data.faqs);
          setIsAnswerVisible(new Array(response.data.faqs.length).fill(false)); // Initialize answer visibility array
          setIsAnswerVisible((prevState) => {
            prevState[0] = true;
            return [...prevState];
          });
        } else {
          console.error("Error:", response.data);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };
    getFAQs();
  }, []);

  const toggleAnswerVisibility = (index) => {
    setIsAnswerVisible((prevState) => {
      const updatedVisibility = [...prevState];
      updatedVisibility[index] = !updatedVisibility[index];
      return updatedVisibility;
    });
  };

  return (
    <section id="faq" className="faq-wrapper">
      <div className="faq">
        <div className="divcontainer6">
          <div className="link4">
            <div className="frequently-asked-questions-parent">
              <h1 className="frequently-asked-questions">
                Frequently Asked Questions
              </h1>
              <div className="have-questions-we">
                Have questions? We have answers!
              </div>
            </div>
          </div>
          <div className="div">
            {faqs.map((faq, index) => (
              <div className="item19" key={index}>
                <div
                  className="contact-form-container"
                  onClick={() => toggleAnswerVisibility(index)}
                >
                  <h3 className="question">{faq.question}</h3>
                  <div
                    className={`answer${
                      isAnswerVisible[index] ? "visible" : ""
                    }`}
                  >
                    <p>{faq.answer}</p>
                  </div>
                </div>
                <div
                  className={
                    isAnswerVisible[index] ? "spanarrow" : "spanarrow1"
                  }
                >
                  <div className="after">
                    <img
                      className="chevron-up-icon"
                      onClick={() => toggleAnswerVisibility(index)}
                      alt=""
                      src={
                        isAnswerVisible[index]
                          ? "/chevron-up@2x.png"
                          : "/chevron-up-1@2x.png"
                      }
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQs;
